import Api from "@/lib/axios";

const SafeguardingService = {
  getTransactionsSummary({ license }) {
    return Api.get("/api/safeguarding/v1/transactions/summary", {
      data: {
        license
      }
    });
  },
  downloadSafeguardingReportFile({
    license, firstAccountUkBalance, firstAccountEuropeBalance,firstAccountCaBalance,
    secondAccountUkBalance, secondAccountEuropeBalance, secondAccountCaBalance, totalBalance
  }) {
    return Api.get("/api/safeguarding/v1/report/get-report.xlsx", {
      responseType: "blob", data: {
        license, firstAccountUkBalance, firstAccountEuropeBalance,firstAccountCaBalance,
        secondAccountUkBalance, secondAccountEuropeBalance,secondAccountCaBalance, totalBalance
      }
    });
  },
  storeSafeguardingReportFileOnDrive({
    license, firstAccountUkBalance, firstAccountEuropeBalance,firstAccountCaBalance,
    secondAccountUkBalance, secondAccountEuropeBalance,secondAccountCaBalance, totalBalance
  }) {
    return Api.post(
        "/api/safeguarding/v1/transactions/store-file", {
          data: {
            license, firstAccountUkBalance, firstAccountEuropeBalance,firstAccountCaBalance,
            secondAccountUkBalance, secondAccountEuropeBalance,secondAccountCaBalance, totalBalance
          }
        });
  },
  getWalletsSummary({license}) {
    return Api.get("/api/safeguarding/v1/wallets/summary", {
      data: {
        license
      }
    });
  },
  getUnifiedSummary({ license }) {
    return Api.get("/api/safeguarding/v2/safeguarding/summary" , {
      data: {
        license
      }
    });
  }
};

export default SafeguardingService;
